// extracted by mini-css-extract-plugin
export var imgWrapper = "styles-module--imgWrapper--vMyex";
export var imgWrapperchecked = "styles-module--imgWrapperchecked--UX1b+";